import { css } from '@emotion/css';

export const main = css`
  text-align: center;
`;
